/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/8/15
 * Time: 11:37
 * Desc: 顾客分销管理-押金管理
 */

import { Component, Vue } from 'vue-property-decorator';
import { noop } from 'lodash';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import { appEnvConfig } from '@/configs/appConfigs';
import { PolicyTypeText } from '@/views/components/newDistribution/newDistributionList';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import Socket from '@/library/socket';
import ExportFile from '@/views/components/exportFile';
import NewSelectSite from '@/views/components/newSelectSIte';

@Component({
  components: {
    NoAuth,
    ExportFile,
  },
})
export default class DepositManage extends Vue {
  /* 数据 */
  /**
   * 当前页面的索引 / 押金状态
   * @type {string}
   */
  public curPage = '1';

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 押金列表
   * @type {Array<GuiderDepositOutList>}
   */
  public depositList: Array<GuiderDepositOutList> = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 排序类型
   * @type {number}
   * @desc 0默认排序(申请倒叙) 1押金由高到低 2押金由低到高
   */
  public sort = 0;

  /**
   * 是否选中列表项
   * @type {boolean}
   */
  public isSelected = false;

  /**
   * 选中的列表
   * @type {Array<GuiderDepositOutList>}
   */
  public selectedList: Array<GuiderDepositOutList> = [];

  /**
   * 拒绝弹窗是否显示
   * @type {boolean}
   */
  public isRejectedReasonPopShow = false;

  /**
   * 拒绝理由类型
   * @type {string}
   */
  public rejectedReasonType = 'self';

  /**
   * 拒绝理由
   * @type {string}
   */
  public rejectedReason = '';

  /**
   * 当前提现记录Id
   * @type {number | string}
   */
  public curOutId: any = 0;

  /**
   * 页面名称
   * @type {ItemObject}
   */
  public pageNameObj: ItemObject = {
    p1: 'VSHOP-FUNCTION-DISTRIBUTE-DEPOSIT-VERIFY1', // 待业务审核
    p2: 'VSHOP-FUNCTION-DISTRIBUTE-DEPOSIT-VERIFY2', // 待总部审核
    p3: 'VSHOP-FUNCTION-DISTRIBUTE-DEPOSIT-PAY', // 待打款
    p4: 'VSHOP-FUNCTION-DISTRIBUTE-DEPOSIT-HASPAY', // 已打款
    p5: 'VSHOP-FUNCTION-DISTRIBUTE-DEPOSIT-HASDENY', // 已拒绝
  };

  $refs: {
    export: ExportFile;
  };

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /**
   * socket连接准备
   * @type {boolean}
   */
  public isSocketReady = false;

  /**
   * 角色类型
   * @type {number | string}
   */
  public tagType = '';

  /**
   * 角色标签列表
   * @type {ItemArray}
   */
  public tagTypeList = [];

  /**
   * 分销类型
   * @type {number | string}
   */
  public distributionType = '';

  /**
   * 分销类型列表
   * @type {ItemArray}
   */
  public distributionTypeList = PolicyTypeText;

  /**
   * 网点列表
   * @type {string[]}
   */
  public siteCodes = [];

  /**
   * 网点树列表
   * @type {ItemArray}
   */
  public siteTreeList = [];

  /* 方法 */

  /**
   * 根据关键字搜索
   * @return null
   */
  public onSearchDepositList(): void {
    this.page = 1;
    this.pageSize = 10;
    this.getDepositList();
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getDepositList();
  }

  /**
   * 页码变更
   * @param {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getDepositList();
  }

  /**
   * 分销类型改变
   * @param {number} val
   */
  public distributionTypeChange(val) {
    this.distributionType = val;
    this.getDepositList();
  }

  /**
   * 角色标签改变
   * @param {number} val
   */
  public tagTypeChange(val) {
    this.tagType = val;
    this.getDepositList();
  }

  /**
   * 选中的活动
   * @param val
   * @return null
   */
  public onHandleSelectionChange(val): void {
    this.isSelected = val.length > 0;
    this.selectedList = val;
  }

  /**
   * 隐藏拒绝理由弹窗
   * @return null
   */
  public onRejectedReasonPopHide(): void {
    this.isRejectedReasonPopShow = false;
    this.rejectedReasonType = 'self';
    this.rejectedReason = '';
  }

  /**
   * 打开拒绝理由弹窗
   * @param {any} val
   * @return null
   */
  public onRejectedReasonPopShow(val: any): void {
    this.isRejectedReasonPopShow = true;
    this.curOutId = val;
  }

  /**
   * 切换页面
   */
  public onPageSwitch(key): void {
    this.keywords = '';
    this.page = 1;
    this.pageSize = 10;
    this.sort = 0;
    this.curPage = key;
    this.isSelected = false;
    this.selectedList = [];
    this.distributionType = '';
    this.tagType = '';
    this.siteCodes = [];
    this.$refs.export.reset();
    this.setCurPageName(key); // 设置当前页索引到缓存
    // 表格恢复到初始状态
    // @ts-expect-error
    this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
    // @ts-expect-error
    this.$refs.multipleTable.bodyWrapper.scrollLeft = 0;
    this.getTagList();
    this.getDepositList(); // 获取押金列表
  }

  /**
   * 列表排序
   * @param {ItemObject} column
   * @return null
   */
  public onSortChange(column: ItemObject): void {
    this.sort = column.order === 'ascending' ? 1 : column.order === 'descending' ? 2 : 0;
    this.getDepositList(); // 获取押金列表
  }

  /**
   * 获取左侧树列表
   * @return null
   */
  // getTreeList() {
  //   return IPSService.getAdminAuthTree().then((response) => {
  //     return response.treeList;
  //   });
  // }

  /**
   * 获取提现管理列表
   * @return null
   */
  public async getDepositList() {
    const loading = this.$loading({
      lock: true,
      text: '请稍等...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
    });
    this.depositList = [];
    const postParams = {
      keywords: this.keywords,
      level: Number.parseInt(this.curPage), // 1待业务审核 2待总部审核 3待打款 4已打款 5已拒绝
      // level : 4, // 1待业务审核 2待总部审核 3待打款 4已打款 5已拒绝
      page: this.page,
      pageSize: this.pageSize,
      sort: this.sort,
      siteCodes: this.siteCodes,
      tagName: `${this.tagType}` ? this.tagTypeList[this.tagType] || '' : '',
      policyType: this.distributionType === '' ? 9 : this.distributionType,
    };
    // if (!this.siteTreeList || !this.siteTreeList.length) {
    //   this.siteTreeList = await this.getTreeList();
    // }
    IPSService.guiderDepositOutList({ postParams }).then(
      (res) => {
        // 格式化数据
        res.list.forEach((item) => {
          item.addTime = Functions.emptyVaribleHandler(item.addTime);
          item.siteName = Functions.emptyVaribleHandler(item.siteName);
          item.siteCode = Functions.emptyVaribleHandler(item.siteCode);
          item.remitNumber = Functions.emptyVaribleHandler(item.remitNumber);
          item.reviewContent1 = Functions.emptyVaribleHandler(item.reviewContent1);
          item.reviewTime1 = Functions.emptyVaribleHandler(item.reviewTime1);
          item.reviewContent2 = Functions.emptyVaribleHandler(item.reviewContent2);
          item.reviewTime2 = Functions.emptyVaribleHandler(item.reviewTime2);
          item.reviewContent3 = Functions.emptyVaribleHandler(item.reviewContent3);
          item.reviewTime3 = Functions.emptyVaribleHandler(item.reviewTime3);
          item.tagName = Functions.emptyVaribleHandler(item.tagName);
        });
        this.totalCount = res.count;
        this.depositList = res.list;
        loading.close();
      },
      () => {
        loading.close();
      },
    );
  }

  /**
   * 点击树节点回调
   * @param {ItemObject} item
   */
  // public onClickNode(item) {
  //   this.page = 1;
  //   this.pageSize = 10;
  //   this.siteCodes = this.getTreeAllSite(item);
  //   this.isSelected = false;
  //   this.selectedList = [];
  //   this.tagType = '';
  //   this.getTagList();
  //   this.getDepositList();
  // }

  /**
   * 获取该节点下所有code
   * @returns {string[]}
   */
  // getTreeAllSite(data) {
  //   const childSite = [];
  //   const deepSearch = (node) => {
  //     if (node.isSite) {
  //       childSite.push(node.code);
  //       return;
  //     } else if (Array.isArray(node.children) && node.children.length) {
  //       node.children.forEach((i) => {
  //         deepSearch(i);
  //       });
  //     }
  //   };
  //   deepSearch(data);
  //   return childSite;
  // }

  /**
   * 押金退回审核通过
   * @param {number} id
   * @return null
   */
  public onConfirmRemit(id: number): void {
    this.$confirm('是否通过？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      type: 'warning',
    }).then(() => {
      const postParams = {
        depositOutIds: `${id}`,
        level: this.curPage === '1' ? 1 : 2, // 1业务审核提交 2总部审核提交  3财务打款(暂无)
      };
      IPSService.guiderDepositPassed({ postParams }).then((res) => {
        if (res) {
          this.$message.success('审核通过');
          this.getDepositList();
        } else {
          this.$message.success('审核失败');
        }
      });
    });
  }

  /**
   * 批量通过
   * @return null
   */
  public onConfirmRemitMult(): void {
    const idList = [];
    if (this.selectedList.length > 0) {
      this.selectedList.forEach((item: any) => {
        idList.push(item.depositOutId);
      });
      this.$confirm('是否批量通过？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning',
      }).then(() => {
        const postParams = {
          depositOutIds: idList.join(),
          level: this.curPage === '1' ? 1 : 2, // 1业务审核提交 2总部审核提交  3财务打款(暂无)
        };
        IPSService.guiderDepositPassed({ postParams }).then((res) => {
          if (res) {
            this.$message.success('批量审核通过');
            this.getDepositList();
          } else {
            this.$message.success('批量审核失败');
          }
        });
      });
    }
  }

  /**
   * 打款
   * @return null
   */
  public onConfirmTransfor(item: any): void {
    this.$confirm(`确定打款给【${item.buyerName}】，金额:${item.deposit}元`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      type: 'warning',
    }).then(() => {
      const postParams = {
        depositOutIds: `${item.depositOutId}`,
        level: 3, // 1业务审核提交 2总部审核提交  3财务打款(暂无)
      };
      IPSService.guiderDepositPassed({ postParams }).then((res) => {
        if (res) {
          this.$message.success('打款成功');
          this.getDepositList();
        } else {
          this.$message.success('打款失败');
        }
      });
    });
  }

  /**
   * 审核弹窗拒绝理由
   * @param {number|string} val
   * @return null
   */
  public onRejectedReasonTypeChange(val: any): void {
    this.rejectedReason = '';
    if (val !== 'self') {
      this.rejectedReason = '押金记录异常';
    }
  }

  /**
   * 提交拒绝押金退回信息
   * @return null
   */
  public onSubmitRemitRejectData(): void {
    const reviewContent = Functions.trim(this.rejectedReason);
    if (reviewContent.length > 0) {
      this.$confirm('是否拒绝押金退回？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning',
      }).then(() => {
        const postParams = {
          depositOutId: Number.parseInt(this.curOutId),
          level: this.curPage === '1' ? 1 : 2, // 1待业务审核 2待总部审核 3待打款 4已打款 5已拒绝
          reviewContent,
        };
        IPSService.guiderDepositReject({ postParams }).then((res) => {
          if (res) {
            this.$message.success('成功拒绝');
            this.getDepositList();
            this.onRejectedReasonPopHide();
          } else {
            this.$message.error('拒绝失败');
          }
        });
      });
    } else {
      this.$message.error('请输入拒绝理由');
    }
  }

  /**
   * 判断菜单权限
   * @param {string} name
   * @return {boolean}
   */
  public menuAuth(name: string): boolean {
    return this.$store.state.authMenuCodeList.includes(name);
  }

  /**
   * 获取当前页索引
   * @return null
   */
  public getNearCurPage(): void {
    // 找到最近的
    if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p1)) {
      this.curPage = '1';
      localStorage.setItem('curPageName', this.pageNameObj.p1);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p2)) {
      this.curPage = '2';
      localStorage.setItem('curPageName', this.pageNameObj.p2);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p3)) {
      this.curPage = '3';
      localStorage.setItem('curPageName', this.pageNameObj.p3);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p4)) {
      this.curPage = '4';
      localStorage.setItem('curPageName', this.pageNameObj.p4);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p5)) {
      this.curPage = '5';
      localStorage.setItem('curPageName', this.pageNameObj.p5);
    }
    this.setCurPageName(this.curPage);
  }

  /**
   * 菜单名称和索引转换
   * @param {string} val
   * @return null
   */
  public getCurPage(val: string): void {
    switch (val) {
      case this.pageNameObj.p1:
        this.curPage = '1';
        break;
      case this.pageNameObj.p2:
        this.curPage = '2';
        break;
      case this.pageNameObj.p3:
        this.curPage = '3';
        break;
      case this.pageNameObj.p4:
        this.curPage = '4';
        break;
      case this.pageNameObj.p5:
        this.curPage = '5';
        break;
    }
  }

  /**
   * 设置当前页名称
   * @return null
   */
  public setCurPageName(key: string): void {
    // 设置缓存
    switch (key) {
      case '1':
        localStorage.setItem('curPageName', this.pageNameObj.p1);
        break;
      case '2':
        localStorage.setItem('curPageName', this.pageNameObj.p2);
        break;
      case '3':
        localStorage.setItem('curPageName', this.pageNameObj.p3);
        break;
      case '4':
        localStorage.setItem('curPageName', this.pageNameObj.p4);
        break;
      case '5':
        localStorage.setItem('curPageName', this.pageNameObj.p5);
        break;
    }
  }

  /**
   * 设置菜单权限
   * @return null
   */
  public menuAuthSet(): void {
    if (localStorage.getItem('curPageName')) {
      this.getCurPage(localStorage.getItem('curPageName'));
    } else {
      this.getNearCurPage();
    }
  }

  /**
   * 获取角色标签列表
   * @return null
   */
  public getTagList() {
    IPSService.guiderTagList({
      postParams: {
        siteCode: this.siteCodes,
      },
    }).then((response) => {
      this.tagTypeList = response.list;
    });
  }
  openSelectSiteDialog() {
    new NewSelectSite().open({
      service: 'authTree',
      selectCodes: this.siteCodes,
      readonly: false,
    }).then((val: string[]) => {
      this.siteCodes = val;
      this.getDepositList()
    }, noop);
  }
  get exportParams() {
    return {
      exportType: 'deposit',
      params: {
        keywords: this.keywords,
        level: Number(this.curPage),
        sort: this.sort,
        policyType: this.distributionType === '' ? 9 : this.distributionType,
        tagName: `${this.tagType}` ? this.tagTypeList[this.tagType] : '',
        siteCodes: this.siteCodes,
      },
    };
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-DISTRIBUTE-DEPOSIT');
    if (this.isContentBodyShow) {
      this.menuAuthSet();
      this.getTagList();
      this.getDepositList();
    }
  }
}
